import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  getSettings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (data) => client.put("/settings", data).then((r) => r.data),
  seed: () => client.post("/seed").then((r) => r.data),

  getDashboard: (month) => client.get("/dashboard", { params: { month } }).then((r) => r.data),
  getTrends: (month) => client.get("/trends", { params: { month } }).then((r) => r.data),

  getCategories: () => client.get("/categories").then((r) => r.data),
  createCategory: (data) => client.post("/categories", data).then((r) => r.data),
  updateCategory: (id, data) => client.put(`/categories/${id}`, data).then((r) => r.data),
  deleteCategory: (id) => client.delete(`/categories/${id}`).then((r) => r.data),
  reorderCategories: (ids) => client.post("/categories/reorder", { ids }).then((r) => r.data),
  getSparklines: (month) => client.get("/sparklines", { params: { month } }).then((r) => r.data),

  getTransactions: (month) => client.get("/transactions", { params: month ? { month } : {} }).then((r) => r.data),
  createTransaction: (data) => client.post("/transactions", data).then((r) => r.data),
  updateTransaction: (id, data) => client.put(`/transactions/${id}`, data).then((r) => r.data),
  deleteTransaction: (id) => client.delete(`/transactions/${id}`).then((r) => r.data),

  getRules: () => client.get("/rules").then((r) => r.data),
  deleteRule: (id) => client.delete(`/rules/${id}`).then((r) => r.data),

  importPreview: (formData) =>
    client.post("/import/preview", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  importCommit: (data) => client.post("/import/commit", data).then((r) => r.data),
  scanReceipt: (formData) =>
    client.post("/receipt/scan", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 60000 }).then((r) => r.data),

  rollover: (month) => client.post("/rollover", null, { params: { month } }).then((r) => r.data),
  rolloverLog: () => client.get("/rollover/log").then((r) => r.data),

  resetData: () => client.post("/reset").then((r) => r.data),
  getRecurring: () => client.get("/recurring").then((r) => r.data),
  createRecurring: (data) => client.post("/recurring", data).then((r) => r.data),
  deleteRecurring: (id) => client.delete(`/recurring/${id}`).then((r) => r.data),
  applyRecurring: (month) => client.post("/recurring/apply", null, { params: { month } }).then((r) => r.data),
  sendEmailSummary: (month) => client.post("/email/summary", null, { params: { month } }).then((r) => r.data),
};

export const fmt = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

export const monthLabel = (m) => {
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthsBack = (count) => {
  const out = [];
  const d = new Date();
  for (let i = 0; i < count; i++) {
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    d.setMonth(d.getMonth() - 1);
  }
  return out;
};

export const shiftMonth = (m, delta) => {
  const [y, mo] = m.split("-").map(Number);
  const d = new Date(y, mo - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const downloadCsv = (filename, rows) => {
  const escape = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = rows.map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
